import { ColorContext } from 'App';
import CurrentGlobalActions from 'components/Connections/CurrentGlobalActions';
import WidgetLoadingAnimation from 'components/Widgets/WidgetLoadingAnimation';
import { usePerms } from 'contexts/PermsContext';
import { useContext, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { getGlobalActions } from 'services/globalActions/globalActions.service';
import { GlobalActionsBuilder } from './GlobalActionsBuilder';

export default function GlobalActions() {
  const [globalActions, setGlobalActions] = useState([]);
  const [showNewGlobalAction, setShowNewGlobalAction] = useState(false);
  const [initialData, setInitialData] = useState();
  const perms = usePerms();
  const navigate = useNavigate();
  const [fetching, setFetching] = useState(true);

  useEffect(() => {
    // fetch integrations
    (async () => {
      if (!(await perms.validatePermissions(['ViewGlobalActions']))) {
        navigate('/404');
        return;
      }

      getGlobalActions().then((res) => {
        setGlobalActions(res.data.result);
        setFetching(false);
      });
    })();
  }, []);
  const theme = useContext(ColorContext);
  if (fetching) {
    return <WidgetLoadingAnimation />;
  }

  return (
    <div className="h-100 d-flex flex-column min-h-0">
      {!showNewGlobalAction && (
        <>
          {/* Scrollable list area */}
          {perms.testPermission([8, 9, 10, 11, 12, 13], ['ViewGlobalActions']) && (
            <div className="flex-grow-1 min-h-0 overflow-auto p-2">
              <CurrentGlobalActions
                data={globalActions}
                setData={setGlobalActions}
                setInitialData={setInitialData}
                setShowNewGlobalAction={setShowNewGlobalAction}
              />
            </div>
          )}

          {/* Footer button area */}
          {perms.testPermission([8, 9, 10, 11, 12, 13], ['Create-EditGlobalActions']) && (
            <div className="flex-shrink-0 d-flex justify-content-end p-2">
              <Button
                variant="dark"
                className="fw-bold px-4 py-2 rounded-3"
                style={{ backgroundColor: theme.primaryHighlight, color: theme.on_highlight }}
                onClick={() => setShowNewGlobalAction(true)}
              >
                Create Global Action
              </Button>
            </div>
          )}
        </>
      )}

      {showNewGlobalAction &&
        perms.testPermission([8, 9, 10, 11, 12, 13], ['Create-EditGlobalActions']) && (
          <GlobalActionsBuilder
            setShowNewGlobalAction={setShowNewGlobalAction}
            setGlobalActions={setGlobalActions}
            initialData={initialData}
            setInitialData={setInitialData}
          />
        )}
    </div>
  );
}
